const getPhone = (me) => {
  const { client, professional } = me || {};

  return client?.profile?.phone || professional?.profile?.phone || null;
};

export default getPhone;
